import React from 'react';
import {
    withStyles,
    ButtonBase,
    Grid,
} from '@material-ui/core';
import TIMUtils from '../../network/TIMUtils';
import DeviceEventEmitter, { EventName } from '../../control/event';
import { withRouter } from 'react-router-dom';
import './MEnvelope.css'

const ICON_MSG = require("../../images/icons/xiaoxi.png");

class MEnvelope extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
        }
    }

    componentDidMount() {
        DeviceEventEmitter.on(EventName.EVENT_TIM_MESSAGE_RECEIVED, this.onMessageReceived, this);
    }

    componentWillUnmount() {
        this.setState = () => false;
        DeviceEventEmitter.off(EventName.EVENT_TIM_MESSAGE_RECEIVED, this.onMessageReceived, this);
    }

    onMessageReceived = (event) => {
        this.setState({ show: true });
    }


    _onClickMessage() {
        if (TIMUtils.PRIMSG.length == 0) return;
        let userId = TIMUtils.PRIMSG[0].from;
        this.props.history.push({ pathname: '/privateletter/' + userId + '/userProfile', data: '系统' });

    }


    render() {
        const { bottom } = this.props;
        if (TIMUtils.PRIMSG.length == 0) {
            return null;
        }
        return (
            <Grid container direction='row' alignItems='center' justify='space-between' style={{
                backgroundColor: 'transparent',
                height: 72,
                position: 'fixed',
                left: 16,
                bottom: bottom ? bottom : 55
            }}>
                <ButtonBase disableRipple onClick={() => this._onClickMessage()}>
                    <img src={ICON_MSG} className='EnvelopeImg' style={{ width: 72, height: 72 }}></img>
                </ButtonBase>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({

}))(MEnvelope));
